import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useHookstate } from '@hookstate/core';
import {
  SIDENAV_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
  LIST_BY_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
  SITEID_GLOBAL_STATE
} from 'globalStore/globalStore';
import { setPinsEditModeReduxStateAction } from 'redux/reduxToolkitServices/_commonReducers/commonReducers';

// Custom hook for page redirections across the application
export const useRedirectToPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hideSubNav } = useHookstate(SITEID_GLOBAL_STATE);
  const { subNavDataState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { listBy, sortBy } = useHookstate(LIST_BY_GLOBAL_STATES);
  const { roundStateGlobal, holeStateGlobal } = useHookstate(FLEET_GLOBAL_STATES);

  const redirectToPage = (redirectPath, handleModalOpen = null) => {
    if (redirectPath === "map") {
      navigate("/map"); // navigation
      subNavDataState.set("MAP"); // side nav
      sideDrawerActiveTabState.set(1); // for highlight
      mapSideNavTabState.set("Cars"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Cars");
    } else if (redirectPath === "actionzone") {
      navigate("/map");
      subNavDataState.set("MAP");
      sideDrawerActiveTabState.set(1);
      mapSideNavTabState.set("Action Zones"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Action Zones");
    } else if (redirectPath === "pins") {
      if (handleModalOpen) {
        handleModalOpen(); //Sub nav
      }
    } else if (redirectPath === "print") {
      navigate("/pins", { state: "color" });
      subNavDataState.set("PINS");
      sideDrawerActiveTabState.set(7);
      mapSideNavTabState.set("Pin Placement"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Pin Placement");
    } else if (redirectPath === "location") {
      navigate("/pins");
      subNavDataState.set("PINS");
      sideDrawerActiveTabState.set(7);
      mapSideNavTabState.set("Pin Placement"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Pin Placement");
      dispatch(setPinsEditModeReduxStateAction(true));
    } else if (redirectPath === "placement") {
      navigate("/pins");
      subNavDataState.set("PINS");
      sideDrawerActiveTabState.set(7);
      mapSideNavTabState.set("Rotation Setup"); //Sub nav
      localStorage.setItem("mapSideNavTabState", "Rotation Setup");
    } else if (redirectPath === "cars") {
      navigate("/fleet");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
      listBy.set("IN USE");
    } else if (redirectPath === "fcr") {
      navigate("/fleet");
      sideDrawerActiveTabState.set(2);
      subNavDataState.set("FLEET");
      localStorage.setItem("mapSideNavTabState", "Usage");
      mapSideNavTabState.set("Usage");
      holeStateGlobal.set(false);
      roundStateGlobal.set(true);
    } else if (redirectPath === "pace") {
      navigate("/pace", { state: "Current" });
      subNavDataState.set("PACE");
      sideDrawerActiveTabState.set(4);
      mapSideNavTabState.set("Current");
      localStorage.setItem("mapSideNavTabState", "Current");
    } else if (redirectPath === "pacereports") {
      navigate("/pace", { state: "Current" });
      subNavDataState.set("PACE");
      sideDrawerActiveTabState.set(4);
      mapSideNavTabState.set("Current");
      localStorage.setItem("mapSideNavTabState", "Current");
    } else if (redirectPath === "ampreports") {
      //ampreports
      navigate("/fleet", { state: "Usage" });
      subNavDataState.set("FLEET");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Usage");
      localStorage.setItem("mapSideNavTabState", "Usage");
    } else if (redirectPath === "pre-round") {
      navigate("/fleet");
      subNavDataState.set("FLEET");
      listBy.set("NONE");
      sortBy.set("car");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    } else if (redirectPath === "battery-notification") {
      navigate("/fleet");
      subNavDataState.set("FLEET");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    } else if (redirectPath === "roundsCompleted") {
      navigate("/fleet");
      subNavDataState.set("FLEET");
      listBy.set("IN USE");
      sortBy.set("pace");
      localStorage.setItem("sortBy", "pace");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    } else if (redirectPath === "amp") {
      navigate("/fleet");
      subNavDataState.set("FLEET");
      sideDrawerActiveTabState.set(2);
      mapSideNavTabState.set("Usage");
      subNavDataState.set("PACE");
      sideDrawerActiveTabState.set(4);
      mapSideNavTabState.set("Pace");
      localStorage.setItem("mapSideNavTabState", "Pace");
    } else if (redirectPath === "dashPace") {
      navigate("/pace");
      subNavDataState.set("PACE");
      sideDrawerActiveTabState.set(4);
      mapSideNavTabState.set("Current");
      localStorage.setItem("mapSideNavTabState", "Current");
    } else if (redirectPath === "dashpathRule") {
      navigate("/map");
      sideDrawerActiveTabState.set(1);
      subNavDataState.set("MAP");
      localStorage.setItem("activeMapSideNavTab", "CPO");
      localStorage.setItem("mapSideNavTabState", "CPO");
      mapSideNavTabState.set("CPO");
    } else if (redirectPath === "welcome") {
      navigate("/ads");
      sideDrawerActiveTabState.set(5);
      subNavDataState.set("ADS");
      localStorage.setItem("mapSideNavTabState", "Campaigns");
      mapSideNavTabState.set("Campaigns");
    } else if (redirectPath === "car-path") {
      navigate("/map");
      sideDrawerActiveTabState.set(1);
      subNavDataState.set("MAP");
      hideSubNav.set(true);
      localStorage.setItem("activeMapSideNavTab", "CPO");
      localStorage.setItem("mapSideNavTabState", "CPO");
      mapSideNavTabState.set("CPO");
    } else if (redirectPath === "today-camp-ads") {
      navigate("/ads");
      sideDrawerActiveTabState.set(5);
      subNavDataState.set("ADS");
      localStorage.setItem("mapSideNavTabState", "Campaigns");
      mapSideNavTabState.set("Campaigns");
    }else if (redirectPath === "announcements") {
      navigate("/messages");
      sideDrawerActiveTabState.set(3);
      subNavDataState.set("Announcements");
      localStorage.setItem("mapSideNavTabState", "Announcements");
      mapSideNavTabState.set("Announcements");
    }else if (redirectPath === "allsitesettings") {
     navigate("/allsitesettings");
      subNavDataState.set("allsitesettings");
      localStorage.setItem("subNavDataState", "allsitesettings");
      localStorage.setItem("sideDrawerActiveTabState", -1);
      sideDrawerActiveTabState.set(-1);
    }
    else if (redirectPath === "") {
      return;
    }
  };

  return redirectToPage;
};

